// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-layout[data-v-480635ba]  .container{width:100%}@media(max-width:599.9px){.page-layout[data-v-480635ba]  .container{width:calc(100% - 40px)}}.page-layout.absoluteHeader .header-wrapper[data-v-480635ba]{position:absolute;top:0;left:0;width:100%;z-index:5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
